import { render, staticRenderFns } from "./App.vue?vue&type=template&id=4d546b39&lang=pug"
var script = {}
import style0 from "./styles/stylesheet.sass?vue&type=style&index=0&prod&lang=sass&external"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports